/**
 * Corps envoyés aux edge functions de création de compte (`invite-member`, `create-driver-account`,
 * `create-merchant-account`) : e-mail et/ou numéro WhatsApp (E.164) + pays du sélecteur, jamais de valeur vide.
 * Module PUR (aucun réseau, aucun client) : testable sans navigateur.
 */
import { corpsContact, type ContactValide } from './contactCompte'
import type { Droits } from './dispatch'

/** Corps envoyé à `invite-member` : e-mail et/ou numéro (E.164) + pays du sélecteur, jamais de valeur vide. */
export function corpsInvitationMembre(m: {
  nom: string
  contact: ContactValide
  role: string
  intitule: string | null
  permissions: Droits
}): Record<string, unknown> {
  return {
    ...corpsContact(m.contact),
    full_name: m.nom,
    role: m.role,
    permissions: m.permissions,
    title: m.intitule,
  }
}

/** Corps envoyé à `create-driver-account` : contact (e-mail et/ou numéro WhatsApp E.164 + pays) + véhicule + paiement. */
export function corpsCreationLivreur(r: {
  nom: string
  contact: ContactValide
  typeVehicule: string
  plaque: string
  modele: string
  fournisseurPaiement: string
  numeroPaiement: string
}): Record<string, unknown> {
  return {
    ...corpsContact(r.contact),
    full_name: r.nom,
    vehicle_type: r.typeVehicule,
    plate: r.plaque,
    model: r.modele,
    payout_provider: r.fournisseurPaiement,
    payout_phone: r.numeroPaiement,
  }
}

/** Corps envoyé à `create-merchant-account` : établissement + contact du gérant (e-mail et/ou numéro WhatsApp E.164 + pays). */
export function corpsCreationMarchand(m: { marchandId: string; contact: ContactValide; nomGerant: string }): Record<string, unknown> {
  return {
    merchant_id: m.marchandId,
    ...corpsContact(m.contact),
    full_name: m.nomGerant,
  }
}

